import { MOOD_IMAGES } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Portfolio() {
    return (
        <section
            id="interiors"
            data-testid="portfolio-section"
            className="bg-pearl py-32 md:py-44"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 md:mb-24">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <p className="eyebrow text-cacao/60 mb-8">
                                <span className="divider-line text-cacao/40 mr-4 align-middle" />
                                Interiors
                            </p>
                        </Reveal>
                        <Reveal delay={120}>
                            <h2
                                data-testid="portfolio-headline"
                                className="font-serif text-cacao text-[2.4rem] sm:text-[3.2rem] md:text-[4.4rem] leading-[1.02]"
                            >
                                Considered spaces,
                                <span className="block italic text-clay-deep">
                                    quietly composed.
                                </span>
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5 flex items-end">
                        <Reveal delay={240}>
                            <p className="text-cacao/75 text-[1rem] leading-[1.85] font-light max-w-[28rem]">
                                {"A selection of the moods, materials and details that shape an Arc & Light home \u2014 soft daylight, raw linen, warm clay, considered restraint."}
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div
                    className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5"
                    data-testid="portfolio-grid"
                >
                    {MOOD_IMAGES.map((img, i) => (
                        <Reveal
                            key={`${img.url}-${i}`}
                            delay={(i % 6) * 70}
                            className="group relative overflow-hidden"
                        >
                            <div className={`${img.aspect} w-full overflow-hidden bg-cacao/5`}>
                                <img
                                    src={img.url}
                                    alt={img.alt}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
                                />
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={300}>
                    <div className="mt-16 md:mt-20 flex justify-center">
                        <a
                            href="#contact"
                            data-testid="portfolio-cta"
                            className="btn-ghost"
                        >
                            Enquire about your project
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
